import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { useContext } from "react";

// ==============================|| CONFIG - HOOKS  ||============================== //

const usePassport = () => useContext(NawyPassportContext);

export default usePassport;
